package org.chiangmeng.qfast.core.data.remote

import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.GoogleAuthProvider
import dev.gitlive.firebase.auth.OAuthProvider
import org.chiangmeng.qfast.core.domain.ports.AuthRepository

class FirebaseAuthRepositoryImpl(
    private val firebaseAuth: FirebaseAuth
) : AuthRepository {

    override fun getCurrentUserId(): String? {
        return firebaseAuth.currentUser?.uid
    }

    override suspend fun signIn(email: String, password: String): Result<String> {
        return try {
            val result = firebaseAuth.signInWithEmailAndPassword(email, password)
            val uid = result.user?.uid ?: throw IllegalStateException("User UID not found")
            Result.success(uid)
        } catch (e: Throwable) {
            Result.failure(e)
        }
    }

    override suspend fun signUp(email: String, password: String): Result<String> {
        return try {
            val result = firebaseAuth.createUserWithEmailAndPassword(email, password)
            val uid = result.user?.uid ?: throw IllegalStateException("User UID not found")
            Result.success(uid)
        } catch (e: Throwable) {
            Result.failure(e)
        }
    }

    override suspend fun signOut() {
        firebaseAuth.signOut()
    }

    override suspend fun deleteAccount(): Result<Unit> {
        return try {
            val user = firebaseAuth.currentUser ?: throw IllegalStateException("User not found")
            user.delete()
            try { firebaseAuth.signOut() } catch (_: Throwable) {}
            Result.success(Unit)
        } catch (e: Throwable) {
            Result.failure(e)
        }
    }

    override suspend fun signInWithGoogle(idToken: String, accessToken: String?): Result<String> {
        return try {
            val credential = GoogleAuthProvider.credential(idToken, accessToken)
            val result = firebaseAuth.signInWithCredential(credential)
            val uid = result.user?.uid ?: throw IllegalStateException("User UID not found")
            Result.success(uid)
        } catch (e: Throwable) {
            Result.failure(e)
        }
    }

    override suspend fun signInWithApple(idToken: String, rawNonce: String): Result<String> {
        return try {
            val credential = OAuthProvider.credential(
                providerId = "apple.com",
                idToken = idToken,
                rawNonce = rawNonce
            )
            val result = firebaseAuth.signInWithCredential(credential)
            val uid = result.user?.uid ?: throw IllegalStateException("User UID not found")
            Result.success(uid)
        } catch (e: Throwable) {
            Result.failure(e)
        }
    }
}
